import * as React from "react"
import { MAPPED_BADGE_ICON } from "../rewardsConstants.js"
import {
  FaBookOpenReader,
  FaBook,
  FaBrain,
  FaBullhorn,
  FaBullseye,
  FaCakeCandles,
  FaCertificate,
  FaChalkboardUser,
  FaChampagneGlasses,
  FaChartLine,
  FaFaceSmile,
  FaFlagCheckered,
  FaFlask,
  FaGears,
  FaGem,
  FaGraduationCap,
  FaHatWizard,
  FaHouse,
  FaKey,
  FaMagnifyingGlass,
  FaMountain,
  FaNetworkWired,
  FaPen,
  FaRibbon,
  FaScrewdriverWrench,
  FaStopwatch,
  FaSuitcaseMedical,
  FaSun,
  FaThumbtack,
  FaTicket,
  FaWrench,
  FaTrophy,
  FaUsers,
  FaStar,
  FaRocket,
  FaWandMagicSparkles,
  FaThumbsUp,
  FaHandshake,
  FaMugHot,
  FaMedal,
  FaLightbulb,
  FaHeart,
  FaAward,
  FaGift,
  FaFire,
  FaDumbbell,
  FaCrown,
  FaBolt,
  FaBell,
  FaComments,
  FaPeoplePulling,
  FaPeopleCarryBox,
  FaBrush,
  FaListCheck,
  FaPuzzlePiece,
  FaSeedling,
  FaAnchor,
  FaBinoculars,
  FaShieldHalved,
  FaHandHoldingMedical,
  FaHandHoldingHeart,
  FaPiedPiperHat
} from 'react-icons/fa6';
import { LuCat } from "react-icons/lu";
import { motion } from 'motion/react';

const BadgeIcon = ({ color = "#C4BFBF", size = 36, height = 36, width = 36, iconName = "award" }) => {

    const style = {size: size, color: color };
    
    const IconMatch = () => {
      switch (iconName) {
      case MAPPED_BADGE_ICON.SEEDLING: return <FaSeedling {...style} />;
      case MAPPED_BADGE_ICON.SHIELD_HALVED: return <FaShieldHalved {...style} />;
      case MAPPED_BADGE_ICON.ANCHOR: return <FaAnchor {...style} />;
      case MAPPED_BADGE_ICON.BINOCULARS: return <FaBinoculars {...style} />;
      case MAPPED_BADGE_ICON.BOOK_OPEN_READER: return <FaBookOpenReader {...style} />;
      case MAPPED_BADGE_ICON.BOOK: return <FaBook {...style} />;
      case MAPPED_BADGE_ICON.BRAIN: return <FaBrain {...style} />;
      case MAPPED_BADGE_ICON.BULLHORN: return <FaBullhorn {...style} />;
      case MAPPED_BADGE_ICON.BULLSEYE: return <FaBullseye {...style} />;
      case MAPPED_BADGE_ICON.CAKE_CANDLES: return <FaCakeCandles {...style} />;
      case MAPPED_BADGE_ICON.CERTIFICATE: return <FaCertificate {...style} />;
      case MAPPED_BADGE_ICON.CHALKBOARD_USER: return <FaChalkboardUser {...style} />;
      case MAPPED_BADGE_ICON.CHAMPAGNE_GLASSES: return <FaChampagneGlasses {...style} />;
      case MAPPED_BADGE_ICON.CHART_LINE: return <FaChartLine {...style} />;
      case MAPPED_BADGE_ICON.FACE_SMILE: return <FaFaceSmile {...style} />;
      case MAPPED_BADGE_ICON.FLAG_CHECKERED: return <FaFlagCheckered {...style} />;
      case MAPPED_BADGE_ICON.FLASK: return <FaFlask {...style} />;
      case MAPPED_BADGE_ICON.GEARS: return <FaGears {...style} />;
      case MAPPED_BADGE_ICON.GEM: return <FaGem {...style} />;
      case MAPPED_BADGE_ICON.GRADUATION_CAP: return <FaGraduationCap {...style} />;
      case MAPPED_BADGE_ICON.HAT_WIZARD: return <FaHatWizard {...style} />;
      case MAPPED_BADGE_ICON.HEART: return <FaHeart {...style} />;
      case MAPPED_BADGE_ICON.HOUSE: return <FaHouse {...style} />;
      case MAPPED_BADGE_ICON.KEY: return <FaKey {...style} />;
      case MAPPED_BADGE_ICON.LIST_CHECK: return <FaListCheck {...style} />;
      case MAPPED_BADGE_ICON.MAGNIFYING_GLASS: return <FaMagnifyingGlass {...style} />;
      case MAPPED_BADGE_ICON.MOUNTAIN: return <FaMountain {...style} />;
      case MAPPED_BADGE_ICON.MUG: return <FaMugHot {...style} />;
      case MAPPED_BADGE_ICON.MEDAL: return <FaMedal {...style} />;
      case MAPPED_BADGE_ICON.LIGHT_BULB: return <FaLightbulb {...style} />;
      case MAPPED_BADGE_ICON.NETWORK_WIRED: return <FaNetworkWired {...style} />;
      case MAPPED_BADGE_ICON.PIPER_HAT: return <FaPiedPiperHat {...style} />;
      case MAPPED_BADGE_ICON.PEOPLE_CARRYING: return <FaPeopleCarryBox {...style} />;
      case MAPPED_BADGE_ICON.PEOPLE_PULLING: return <FaPeoplePulling {...style} />;
      case MAPPED_BADGE_ICON.PEN: return <FaPen {...style} />;
      case MAPPED_BADGE_ICON.RIBBON: return <FaRibbon {...style} />;
      case MAPPED_BADGE_ICON.SCREWDRIVER_WRENCH: return <FaScrewdriverWrench {...style} />;
      case MAPPED_BADGE_ICON.STOPWATCH: return <FaStopwatch {...style} />;
      case MAPPED_BADGE_ICON.SUITCASE_MEDICAL: return <FaSuitcaseMedical {...style} />;
      case MAPPED_BADGE_ICON.SUN: return <FaSun {...style} />;
      case MAPPED_BADGE_ICON.THUMBTACK: return <FaThumbtack {...style} />;
      case MAPPED_BADGE_ICON.TICKET: return <FaTicket {...style} />;
      case MAPPED_BADGE_ICON.WRENCH: return <FaWrench {...style} />;
      case MAPPED_BADGE_ICON.WAND: return <FaWandMagicSparkles {...style} />;
      case MAPPED_BADGE_ICON.THUMBS_UP: return <FaThumbsUp {...style} />;
      case MAPPED_BADGE_ICON.HANDSHAKE: return <FaHandshake {...style} />;
      case MAPPED_BADGE_ICON.HAND_PLUS: return <FaHandHoldingMedical {...style} />;
      case MAPPED_BADGE_ICON.PUZZLE: return <FaPuzzlePiece {...style} />;
      case MAPPED_BADGE_ICON.AWARD: return <FaAward {...style} />;
      case MAPPED_BADGE_ICON.HAND_HEART: return <FaHandHoldingHeart {...style} />;
      case MAPPED_BADGE_ICON.GIFT: return <FaGift {...style} />;
      case MAPPED_BADGE_ICON.FIRE: return <FaFire {...style} />;
      case MAPPED_BADGE_ICON.DUMBELL: return <FaDumbbell {...style} />;
      case MAPPED_BADGE_ICON.CROWN: return <FaCrown {...style} />;
      case MAPPED_BADGE_ICON.BRUSH: return <FaBrush {...style} />;
      case MAPPED_BADGE_ICON.BOLT: return <FaBolt {...style} />;
      case MAPPED_BADGE_ICON.BELL: return <FaBell {...style} />;
      case MAPPED_BADGE_ICON.COMMENTS: return <FaComments {...style} />;
      case MAPPED_BADGE_ICON.TROPHY: return <FaTrophy {...style} />;
      case MAPPED_BADGE_ICON.USERS: return <FaUsers {...style} />;
      case MAPPED_BADGE_ICON.STAR: return <FaStar {...style} />;
      case MAPPED_BADGE_ICON.ROCKET: return <FaRocket {...style} />;

      default: return <LuCat {...style} />;
    }
  };
  return (
        <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.4,
                scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
            }}
        >
          <IconMatch />
        </motion.div>
  );
}
export default BadgeIcon